module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"breadcrum":"SK핀크스 정책","Policy_title":"SK핀크스 정책"},"en":{"breadcrum":"SK Pinx Policy","Policy_title":"SK Pinx Policy"},"ja":{}}')
  delete Component.options._Ctor
}
